import { InjectionToken } from '@angular/core';
import type { ClimbTable, ClimbColumnDef } from './table.interface';

/**
 * Used to provide a table to some of the sub-components without causing a circular dependency.
 */
export const CLIMB_TABLE = new InjectionToken<ClimbTable<any>>('CLIMB_TABLE');

export const CLIMB_COLUMN_DEF = new InjectionToken<ClimbColumnDef>('CLIMB_COLUMN_DEF');
